import formatISO from "date-fns/formatISO";
import sub from "date-fns/sub";

const getCurrentDate = () => Date.now();

export const getChartDummyData = (daysToRepresentInChart) => {
  // returns random chart data against each day
  const tempData = [...new Array(daysToRepresentInChart)].map((_, index) => {
    const dt = formatISO(sub(getCurrentDate(), { days: index }), {
      representation: "date",
    });
    return { date: dt, value: Math.floor(Math.random() * 35) };
  });
  return tempData;
};
